<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Conversations</h3>

    <label>Conversations Active Period <small>(default: 5)</small></label>
    <p class="hint">
      The amount of time (in minutes) after which a conversation is to be declared 'closed' due to inactivity.
    </p>
    <input v-model="resource.conversations_active_period" type="number" />
    
    <span v-if="errors.conversations_active_period" class="alert -inline -danger">
      {{ [...errors.conversations_active_period].join(', ') }}
    </span>

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import dig from 'object-dig';

import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["conversations_active_period"]
    };
  },

  methods: {
    dig
  }
};
</script>
